export default function MobileActionButtons() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 lg:hidden bg-white border-t border-gray-200 shadow-lg">
      <div className="grid grid-cols-2 gap-0">
        <a
          href="tel:+78124081913"
          className="flex items-center justify-center gap-2 py-4 bg-[#1A2B4A] text-white hover:bg-[#0F1A2E] transition-colors cursor-pointer"
        >
          <i className="ri-phone-line text-xl"></i>
          <span className="text-base font-medium whitespace-nowrap">Позвонить</span>
        </a>
        <a
          href="mailto:sales@engvar.ru"
          className="flex items-center justify-center gap-2 py-4 bg-white text-[#1A2B4A] border-l border-gray-200 hover:bg-gray-50 transition-colors cursor-pointer"
        >
          <i className="ri-mail-line text-xl"></i>
          <span className="text-base font-medium whitespace-nowrap">Написать</span>
        </a>
      </div>
    </div>
  );
}